import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Account Management</Typography>
      <p>This short form is used to maintain your account details.</p>

      <p>Please ensure you keep your details up-to-date.</p>
    </div>
  )
}

export default HelpText